export default {
  route: {
    home: 'Home',
    waybill: 'Waybill',
    addWaybill: 'AddWaybill',
    editWaybill:'EditWaybill',
    modifyWaybill:'ModifyWaybill',
    waybillPrinting: 'WaybillPrinting',
    batchImport: 'batchImport',
    routing: 'Routing',
    address: 'Address',
    receipt: 'Receipt',
    system: 'System',
    i18n: 'I18n',
    generate:'Generate Waybill',
    Balance:'Balance Details',
    charges:'Waybill Charges'
  },
  charges:{
    date:'Query Date'
  },
  login: {
    cxcTitle: 'CXC Login Form',
    logIn: 'Login',
    register:'Register',
    username: 'Username',
    password: 'Password',
    userNameEmpty:'The user name cannot be empty',
    userNameRules:'Please enter the correct user name',
    passwordRules:'The password cannot be less than 6 digits',
    passwordEmpty:'Password cannot be empty',
  },
  home: {
    serviceV1: 'Documentation',
    agree:'Agree',
    disagree: 'Disagree',
    notice:'Announcement',
  },
  search:{
    search1:'Search',
    reset1:'Reset'
  },
  table:{
    no:'Order number',
    createTime:'Generation time',
    waybillSchOrder:'Waybill number',
    waybillPlainOrder:'Original waybill No',
    dateReceived:'Date received',
    addressee:'Addressee',
    phone: 'Contact number',
    toAdress: 'To address',
    Region:'Region',
    Microzone:'Microzone',
    weight: 'Weight',
    settlementWay: 'Settlement Way',
    printStatus:'Print status',
    operation: 'Operation',
    download:'Issue',
    modify:'Modify',
    print:'Print',
    receiving:'Receiving',
    submit:'Submit',
    cancel: 'Cancel',
    delete: 'Delete',
    confirm: 'Confirm',
    routingTime:'Routing time',
    routingDetails:'Route details',
    remarks:'Remark',
    customerName:'Customer name',
    editor:'Editor',
  },
  waybill: {
    freight:'Freight Prepaid / Collect',
    waybillManagement:'Waybill management',
    waybillSchOrder:'Waybill number',
    waybillPlainOrder:'Original waybill No',
    waybillList:'Waybill list',
    waybillPrinting:'Waybill printing',
    RefreshWaybill:'Update waybill',
    exportWaybill:'Export waybill',
    newWaybill:'New waybill',
    batchImport:'Batch import',
    batchCancel:'Batch cancel',
    templateDownload:'Template download',
    toAdress: 'To address',
    phone: 'Contact number',
    products:'Products',
    Waybillno:"Waybill No",
    schStatus: 'Order status',
    printStatus:'Print status',
    a4Printing:'A4 printing',
    thermalPrinting:'Thermal printing',
    time: 'Time',
    singleTime: 'Single Time',
    startDate:'Start date',
    endDate:'End date',
    delete: 'Delete',
    confirm: 'Confirm',
    cancel: 'Cancel',
    orderModification:'Order modification',
    orderNumber:'Order number',
    orderTime:'Order time',
    shippingAddress:'Shipping address',
    tel:'Contact number',
    distributor:'Distributor',
    status:'status',
    confirm2: 'confirm',
    PleaseTime:'Please enter the time',
    PleaseAddress:'Please enter the address',
    PleasePhone:'Please enter the contact information',
    PleaseName:'Please enter name',
    PleaseOrderStatus:'Please enter order status',
  },
  addWaybill: {
     // 新建運單
     customerInfo:'Customer information',
     companyName:'Company name',
     customerOriginalWaybill:'Customer original waybill',
     dateReceived:'Date received',
     receivingInfo:'Receiving information',
     addressee:'Addressee',
     commodityInfo:'Commodity information',
     commodityContent:'Commodity content',
     quantity:'Quantity',
     unitPrice:'Unit price',
     totalValue:'Total value',
     totalWeight:'Total weight',
     collectionService:'Collection service',
     collectFreight:'Collect freight',
     collectPayment:'Collection of payment for goods',
     collectTotalFees:'Collection of total fees',
     remark:'Remark',
  },
  routing: {
    routingQuery: 'Routing query',
    routingInfo: 'Routing information',
    waybillAccepted:'Waybill accepted',
    pickUp: 'Have come to pick up',
    warehousing: 'Already in warehouse',
    onTheWay: 'On the way',
    pickedUpSuccessfully: 'Successfully retrieved',
  },
  address: {
    addressManagement: 'Address management',
    receivingCompany:'Receiving company',
    addressList:'Address list',
    addAddress:'New address',
    batchDeletion:'Batch deletion',
  },
  receipt: {
    pickupConfig: 'Pickup configuration',
    status: 'status',
    receivingList:'Receiving list',
    addReceipt:'New receipt',
    batchDeletion:'Batch deletion',
    taskNumber:'Task number',
    quantityReceived:'Quantity received',
    submitDate:'Submit Date',
    visitingTime:'Visiting time',
    actualQuantity:'Actual quantity',
    orderModify:'Order modification',
    totalWeight:'Total weight',
    overallDimensions:'Overall dimensions',
    pleaseQuantity:'Please input quantity',
    pleaseTotalWeight:'Please enter the total weight',
    pleaseTotalSize:'Please input the total size',
    pleaseRemarks:'Please enter the remarks',
  },
  batchImport:{
    batchImportProcess:'Batch import process',
    downloadTemplate:'Download template',
    message:'Fill in the information',
    uploadFiles:'Upload files',
    editAndModify:'Edit and modify',
    confirmImport:'Confirm import',
    clickUploadFile:'Click upload file',
    importNotice:'Import instructions',
    matter1:'1.To ensure the import success rate, please fill in the waybill information according to the format specified in the template',
    matter2:'2.The successful import waybill can be saved to the system. The failed waybill can be viewed and modified below. After modification, it can be saved to the system through the import success list.',
    matter3:'3.Only excel tables can be uploaded to the imported file. The file size should be less than 5M',
    tip1:'Data import, do not operate......',
    tip2:'Data import complete',
    importSuccess:'Import succeeded',
    importFail:'Import failed',
    // 批量導入文件的顯示
    companyName:'Company Name',
    waybillNo:'Waybill No',
    orderNo:'Order No',
    products:'Product',
    addressee:'*Recipient',
    phone: '*Phone Number',
    address: '*Address',
    commodityContent:'*commodity',
    freight:'*Freight Prepaid / Collect',
    retrieve:'Whether to retrieve the parts',
    long:'*long',
    wide:'*wide',
    high:'*high',
    number:'*Quantity',
    totalWeight: '*Total Weight',
    collectPayment:'COD',
    remarks:'Remarks',
  },
  system: {
    export: 'Export',
    selectedExport: 'Export Selected Items',
    placeholder: 'Please enter the file name (default excel-list)'
  },
}
